exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".excel[data-v-70d8ab4a]{color:#fff;background:#2acc6b;border-radius:4px!important;padding:10px 28.86px;border:none;transition:.2s}.excel[data-v-70d8ab4a],.excel span[data-v-70d8ab4a]{display:flex;align-items:center}.excel[data-v-70d8ab4a]:active,.excel[data-v-70d8ab4a]:hover{background:#08a747}.excel i[data-v-70d8ab4a]{font-size:20px;margin-right:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-70d8ab4a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/buttons/btnExcel.vue
// module id = 700
// module chunks = 0